module.exports = __webpack_public_path__ + "img/55.b9ba20c5.jpg";